
    import './styles.scoped.css';
    export default {
  "variant-normal": "awsui_variant-normal_1a743_ssffh_9",
  "pressed": "awsui_pressed_1a743_ssffh_9",
  "variant-icon": "awsui_variant-icon_1a743_ssffh_15"
};
  